import { useNavigation, Outlet } from 'react-router';
import { LostAndFoundSkeleton, MapSkeleton, SolvedCasesSkeleton } from '@/components/Skeletons';

export const RouteTransition = () => {
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';
  const targetPath = navigation.location?.pathname;

  if (!isLoading) return <Outlet />;

  // esto no escala ni mierda, pero bueno se me ocurrio esto por ahora.
  if (targetPath === '/lost' || targetPath === '/found') {
    return <LostAndFoundSkeleton />;
  }

  if (targetPath === '/map') {
    return <MapSkeleton />;
  }

  if (targetPath === '/solved-cases') {
    return <SolvedCasesSkeleton />;
  }

  return (
    <div className="flex h-96 items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-t-transparent" />
    </div>
  );
};
